// extracted by mini-css-extract-plugin
module.exports = {"header":"bills_header__2XFtj","table":"bills_table__1ICPJ","section":"bills_section__3JdmY","sectionTitle":"bills_sectionTitle__2q7lO"};